import { render, staticRenderFns } from "./Randevu.vue?vue&type=template&id=95cd83c4&scoped=true&"
import script from "./Randevu.vue?vue&type=script&lang=js&"
export * from "./Randevu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd83c4",
  null
  
)

export default component.exports